import { styled } from '@mui/material'
import { BETWEEN_CARDS_SPACING } from 'redesign/shared/constants'

export const Container = styled(`div`)`
  display: flex;
  flex-direction: column;
`

export const BodyContainer = styled(`div`)`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-self: stretch;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(BETWEEN_CARDS_SPACING)};
`
